<template>
  <b-row class="category-choose" no-gutters>
    <b-col>
      <b-form-select class="mr-2" v-model="selected" :options="options" :disabled="parentChangeDisabled || isBusy"/>
    </b-col>
    <b-col>
      <b-form-input
        class="mr-5"
        :disabled="isBusy"
        v-model="value"
        placeholder="Wprowadź nazwe nowej kategorii wydatku" />
    </b-col>
    <b-col v-if="!hideAddButton">
      <button
        class="btn btn-outline-success btn-sm m-1 mr-4"
        @click="add"
        :disabled="value.length === 0 || isBusy">
        Dodaj
      </button>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "categoryInput",
  props: {
    parentId: Number,
    parentChangeDisabled: Boolean,
    isBusy: Boolean,
    hideAddButton: Boolean,
    options: Array
  },
  data() {
    return {
      selected: 0,
      value: "",
    }
  },
  methods: {
    add() {
      this.$emit('add', {
        selected: this.selected,
        value: this.value
      });
    },
    set({value, selected}) {
      this.value = value;
      this.selected = selected;
    },
    get() {
      return {value: this.value, selected: this.selected}
    },
    reset() {
      this.selected = this.parentId;
      this.value = "";
    }
  },
  mounted() {
    this.selected = this.parentId;
  }
};
</script>